import React, { Fragment } from 'react'
import classnames from 'classnames'

import {
  useBrandColor,
  useBrandGraphic,
} from '../../Designs/blocs/brandResolvers'
import { useFloorState } from '../../firebase/hooks/useFloor'
import { useEditingMixState } from '../../firebase/hooks/useMixes'
import { useRole } from '../../global/blocs/roomInfo'
import { useSortedHumanParticipants } from '../../webrtc/webRTCRoom'
import { useLayoutSettings } from '../layouts'
import { MixEditingToolbar } from '../MixEditing/MixEditingToolbar/MixEditingToolbar'
import { MixSlotMenu } from '../MixEditing/MixSlotMenu/MixSlotMenu'

import { EmptyMixSlots } from './EmptyMixSlots/EmptyMixSlots'
import { FloorCameraFeed } from './FloorFeed/FloorCameraFeed/FloorCameraFeed'
import { FloorMobileFeed } from './FloorFeed/FloorMobileFeed/FloorMobileFeed'
import { FloorScreenFeed } from './FloorFeed/FloorScreenFeed/FloorScreenFeed'
import { FloorTrayFeed } from './FloorFeed/FloorTrayFeed/FloorTrayFeed'
import { StaticElements } from './StaticElements/StaticElements'

import './floor.scss'

const Floor = () => {
  const floor = useFloorState()
  const participants = useSortedHumanParticipants()
  const editingMix = useEditingMixState()
  const role = useRole()
  const layoutSettings = useLayoutSettings()
  const resolveBrandColor = useBrandColor()
  const resolveBrandGraphic = useBrandGraphic()

  if (!floor) return null

  const identifier = 'identifier' in floor ? floor.identifier : undefined

  const backgroundColor = resolveBrandColor(layoutSettings?.backgroundColor)
  const backgroundImage = resolveBrandGraphic(layoutSettings?.backgroundImage)

  return (
    <div
      className={classnames('floor', {
        'transitions-enabled': false,
        'editing-mix': editingMix,
      })}
      data-layout={editingMix ? 'custom' : floor.layout}
      data-identifier={identifier}
      style={{
        '--layout-background-color': backgroundColor,
        '--layout-background-image': backgroundImage
          ? `url(${backgroundImage})`
          : '',
      }}
    >
      {participants.map((participant) => (
        <Fragment key={participant.id}>
          <FloorCameraFeed id={participant.id} />
          <FloorScreenFeed id={participant.id} />
          <FloorMobileFeed id={participant.id} />
        </Fragment>
      ))}
      <FloorTrayFeed />

      <StaticElements />

      {role === 'producer' && (
        <>
          <EmptyMixSlots />
          <MixEditingToolbar />
          <MixSlotMenu />
        </>
      )}
    </div>
  )
}

export { Floor }
